<p-dialog [header]="emailGenerationScenario.header" [(visible)]="displayDialog" (onHide)="onDialogClose()" [modal]="true" [responsive]="true" [style]="{width: '45vw'}">
    <form class="card" [formGroup]="emailGenerationForm">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Describe your scenario <span style="color: red;">*</span></label>
                <p-editor formControlName="scenario" [style]="{'height':'200px'}"></p-editor>

                <div *ngIf="detailsFormErrors?.scenario" class="p-invalid">
                    <small>{{ detailsFormErrors?.scenario }}</small>
                </div>
            </div>
            <div class="p-col-12">
                <label>Tone <span style="color: red;">*</span></label>
                <p-dropdown [options]="tone" optionLabel="name" formControlName="tone" appendTo="body"></p-dropdown>

                <div *ngIf="detailsFormErrors?.tone" class="p-invalid">
                    <small>{{ detailsFormErrors?.tone }}</small>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="getGenerateEmail()" label="{{isLoadingEmailGenerationScenario? 'Generating...' : 'Generate'}}" [loading]="isLoadingEmailGenerationScenario"></button>
    </p-footer>
</p-dialog>
